import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
    searchRegions: (filterRequest) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'region/search',
                    method: 'POST',
                    body: filterRequest,
                    types: [
                        types.SEARCH_REGION_REQUEST,
                        types.SEARCH_REGION_SUCCESS,
                        types.SEARCH_REGION_FAILURE
                    ]
                }
            });
        },

    saveRegion: (region) =>
        (dispatch) => {
            if (region.id === 0) {
                // Create
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'region/create',
                        method: 'POST',
                        body: region,
                        types: [
                            types.CREATE_REGION_REQUEST,
                            types.CREATE_REGION_SUCCESS,
                            types.CREATE_REGION_FAILURE
                        ]
                    }
                });
            } else {
                // Update
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'region/update',
                        method: 'PUT',
                        body: region,
                        types: [
                            types.UPDATE_REGION_REQUEST,
                            types.UPDATE_REGION_SUCCESS,
                            types.UPDATE_REGION_FAILURE
                        ]
                    }
                });
            }
        }
}
